<div id="sidebar" [class.show]="sidebarStatus">
  <ul>
    <li *ngFor="let entry of getMenuItems(); let i = index"
        [routerLinkActive]="entry.submenu ? 'activeDropdown' : 'active'"
        [ngClass]="{'hasSubmenu': entry.submenu}">

      <!-- Internal links -->
      <a *ngIf="!entry.isExternalLink && !entry.submenu" [routerLink]="entry.url" [attr.yp-e2e-id]="entry.e2eId ? entry.e2eId : ''">
        <i *ngIf="entry.fontAwesomeClass" [class]="entry.fontAwesomeClass"></i>
        <span>{{entry.title}}</span>
        <span class="badge" *ngIf="entry.notification && notifications[entry.notification.name] > 0">
          {{notifications[entry.notification.name]}}
        </span>
      </a>

      <!-- External links -->
      <a *ngIf="entry.isExternalLink && !entry.submenu" [href]="entry.url" [attr.yp-e2e-id]="entry.e2eId ? entry.e2eId : ''">
        <i *ngIf="entry.fontAwesomeClass" [class]="entry.fontAwesomeClass"></i>
        <span>{{entry.title}}</span>
        <span class="badge" *ngIf="entry.notification && notifications[entry.notification.name] > 0">
          {{notifications[entry.notification.name]}}
        </span>
      </a>

      <!-- Dropdown links -->
      <a *ngIf="entry.submenu" href="#" [attr.yp-e2e-id]="entry.e2eId ? entry.e2eId : ''"
         class="subMenuToggle"
         [ngClass]="{'isActive': entry.isOpen}"
         (click)="$event.preventDefault(); toggleDropdown(i)">
        <i *ngIf="entry.fontAwesomeClass" [class]="entry.fontAwesomeClass"></i>
        <span>{{entry.title}}</span>
      </a>

      <ul class="subMenu" *ngIf="entry.submenu">
        <li *ngFor="let entrySub of entry.submenu" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
          <a [routerLink]="entrySub.url" [attr.yp-e2e-id]="entrySub.e2eId ? entrySub.e2eId : ''">
            <i *ngIf="entrySub.fontAwesomeClass" [class]="entrySub.fontAwesomeClass"></i>
            <span>{{entrySub.title}}</span>
          </a>
        </li>
      </ul>
    </li>
  </ul>
</div>
